<template>
    <div>
        <HeadNav selectedLanguage="en" page="download" />
        <div class="features-section features-bgList">
<h1>GB WhatsApp Old Version Download - Stable & Lightweight APKs</h1>
            <div>
                While the latest versions of <a href="https://gbmodshub.com/" class="jump-url"> GB WhatsApp</a> often
                come with new features, many users still prefer
                <strong>older versions GB WhatsApp</strong>
                for their stability, compatibility, and user-friendly interface. This page is your
                one-stop destination for safe and direct <strong>GB WhatsApp APK old version download </strong>links.
                Whether you're
                using an older Android device or prefer the classic interface, we offer multiple versions to meet your
                needs.
            </div>
            <!-- <h2></h2> -->
            <button class="latest-btn" @click="gotodownload">GB WhatsApp Latest Version-V18.50 Download</button>
            <div class="version-table">
                <div class="older-version">
                    <img src="@/assets/older.webp" alt="">
                </div>
                <div class="figure-table">
                    <figure class="wp-block-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>App</th>
                                    <th>GB WhatsApp</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Size</td>
                                    <td>72M</td>
                                </tr>
                                <tr>
                                    <td>Version</td>
                                    <td>V18.50</td>
                                </tr>
                                <tr>
                                    <td>Update</td>
                                    <td>2 days ago</td>
                                </tr>
                                <tr>
                                    <td>Site</td>
                                    <td><a href="https://gbmodshub.com/" class="jump-url">https://gbmodshub.com/</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </figure>
                    <!-- <button class="free-download-btn1">Download the latest version</button> -->
                </div>
            </div>
            <h2 class="intro-title">GB WhatsApp Older Versions Download(Safe APK Files) </h2>
            <div>
                Below is a curated list of GB WhatsApp old APK versions, sorted by popularity and stability. Choose the
                one that best fits your device and preferences:
            </div>
            <div>
                <div class="figure-table">
                    <figure class="wp-block-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Version</th>
                                    <th>Release Date</th>
                                    <th>File Size</th>
                                    <th>Download Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>v18.30</td>
                                    <td>December 9, 2024</td>
                                    <td>75MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v18.20</td>
                                    <td>November 10, 2024</td>
                                    <td>75MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v18.10</td>
                                    <td>September 2021</td>
                                    <td>75MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v18. 00</td>
                                    <td>June 2020</td>
                                    <td>72MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v17.85</td>
                                    <td>May 2024</td>
                                    <td>78MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v17.80</td>
                                    <td>May 2024</td>
                                    <td>78MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v17.76</td>
                                    <td>April 2024</td>
                                    <td>78MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v17.60</td>
                                    <td>December 2023</td>
                                    <td>78MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                                <tr>
                                    <td>v17.55</td>
                                    <td>October 2023</td>
                                    <td>78MB</td>
                                    <td><a class="jump-url" @click="gotodownload()">Download</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </figure>
                </div>
                📌 Tip: Make sure to back up your chats before installing a different version.
            </div>
            <br>
            <h2 class="intro-title">How to Install GB WhatsApp APK Old Version</h2>
            <div class="quick-overview">
                Follow these simple steps to download and install GB WhatsApp old version APK on your Android phone:
                <ol>
                    <li> <strong>Download the APK</strong> – Click the download button for your preferred version from
                        the list above.</li>
                    <li> <strong>Enable unknown sources</strong> – Go to Settings > Security > Enable “Install apps from
                        unknown
                        sources”.</li>
                    <li> <strong>Uninstall current GB WhatsApp (optional)</strong> – If you’re switching versions,
                        uninstall the current
                        one or use a package with a different name.</li>
                    <li> <strong>Install the APK</strong> – Open the downloaded APK and follow the installation
                        instructions.</li>
                    <li> <strong>Verify your phone number</strong> – Complete the registration process and restore your
                        chat backup if
                        available.</li>
                </ol>
            </div>
            <h2 class="intro-title">Frequently Asked Questions (FAQ)</h2>
            <div class="quick-overview">
                <div>
                    <strong>❓ Can I use GB WhatsApp old version and official WhatsApp together?</strong> <br>
                    Yes. If you install GB WhatsApp with a different package name (like com.gbwhatsapp), you can run
                    both on the same phone.
                </div>
                <br>
                <div>
                    <strong>❓ Is GB WhatsApp old version safe to use?</strong> <br>
                    It depends on the source. If you download from a trusted and verified site, the risk is minimal.
                    Always check APK integrity before installing.
                </div>
                <br>
                <div>
                    <strong>❓ What Android versions support GB WhatsApp old versions?</strong> <br>
                    Most old versions work well with Android 5.0 (Lollipop) and above. Some may also run on Android 4.4
                    (KitKat).
                </div>
                <br>
                <div>
                    <strong>❓ Can I upgrade to a newer version later?</strong> <br>
                    Yes. You can upgrade any time by downloading a newer APK and installing it over the current one.
                    Make sure to back up your chats first.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
    name: 'Version',
    components: {
        HeadNav},
    data() {
        return {
            apk: null,
        }
    },
    mounted() {
        this.getOfficalApk();
    },
    methods: {
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }

                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        goJump(url) {
            window.location.href = url;
        },
        gotodownload() {
            console.log(this.apk);
            // this.showapk = true
            if (this.apk) {
                this.$global.download(this.apk);
            }

        },
    }
}
</script>